export interface StorefrontItem {
  id: number
  name: string
  url: string
  price: string
  cover_image_url: string | null
  pre_sale: boolean
  soldout: boolean
  low_stock: boolean
  variants: Array<{ id: number; label: string }>
}

interface ProductCardProps {
  item: StorefrontItem
  i18n: {
    soldout: string
    last_pieces: string
    no_image: string
    pre_sale: string
  }
}

export default function ProductCard({ item, i18n }: ProductCardProps) {
  const showSoldoutBadge = item.soldout && !item.pre_sale
  const showLowStockBadge = item.low_stock && !item.soldout && !item.pre_sale

  return (
    <a href={item.url} className="block group">
      <div className="flex flex-col">
        {item.cover_image_url ? (
          <div
            className="relative w-full overflow-hidden rounded-sm mb-6"
            style={{ aspectRatio: "2/3" }}
          >
            <img
              src={item.cover_image_url}
              alt={item.name}
              width={400}
              height={600}
              className="w-full h-full object-cover object-center"
              loading="lazy"
            />
            {(item.pre_sale || showSoldoutBadge || showLowStockBadge) && (
              <div className="absolute top-4 left-4 flex flex-col gap-2">
                {item.pre_sale && (
                  <span className="bg-gray-200 text-content text-sm font-medium px-3 py-1 rounded">
                    {i18n.pre_sale}
                  </span>
                )}
                {showSoldoutBadge && (
                  <span className="bg-gray-200 text-content text-sm font-medium px-3 py-1 rounded">
                    {i18n.soldout}
                  </span>
                )}
                {showLowStockBadge && (
                  <span className="bg-gray-200 text-content text-sm font-medium px-3 py-1 rounded">
                    {i18n.last_pieces}
                  </span>
                )}
              </div>
            )}
          </div>
        ) : (
          <div
            className="relative w-full overflow-hidden rounded-sm mb-6 bg-gray-200 flex items-center justify-center"
            style={{ aspectRatio: "2/3" }}
          >
            <span className="text-gray-500">{i18n.no_image}</span>
          </div>
        )}

        <h3 className="font-unsf-title text-lg font-bold leading-tight mb-2">
          {item.name}
        </h3>

        <span className="font-unsf text-lg font-light mb-4">{item.price}</span>

        {item.variants.length > 0 && (
          <div className="flex flex-wrap gap-2">
            {item.variants.map((variant) => (
              <span
                key={variant.id}
                className="bg-gray-200 text-content text-sm font-medium px-3 py-1 rounded"
              >
                {variant.label}
              </span>
            ))}
          </div>
        )}
      </div>
    </a>
  )
}
